export function generateCatFilterStr(param) {
  const { cats, plat, title, entity } = param
      let brand = param.brand ? param.brand : ''
      let currentPlat = plat
      const shouzhi = require('../../assets/youshouzhi.svg')
  return `
  <div class="confirm-params-area">
  确认您需要的参数
  <div class="confirm-params-desc">
    我从您的问题中抽取了一些信息，包括类目、商品标题关键词、品牌等，我们用这些信息查询数据库，但我的识别可能有误，您可以修改，然后点击确认按钮继续
  </div>
            <div class="cat-params-area">
              <div style='display: flex'>
                <label style="width: 110px">目标平台:</label>
                <span>${currentPlat}</span>
              </div>
              <div style='display: flex;position: relative;'>
                <span style="position: absolute; top: 25px;font-size: 12px; color: gray;width: 100px">最多选择3个一级类目，总共不能超过30个类目
</span>
                <label style="width: 110px">目标类目:</label>
                <div style="display: flex; flex-direction: column; width: 80%">
                  <div style="display: flex;align-items: center;margin-bottom: 10px;">
                    <input placeholder="搜索类目" class="el-input__inner" style="height: 28px;line-height: 28px;width: calc(80% - 40px);display: block" id="catSearchInput"/>
                    <button type="button" class="el-button el-button--primary el-button--mini" style="font-size: 16px; width: 30px;margin-top: 0px;padding: 5px;width: 28px;height: 28px;border-radius: 0;opacity: .9;" id="catSearchBtn">
                      <i class="el-icon-search"></i>
                    </button>
                    <i class="el-icon-question cat-question-icon"></i>
                  </div>
                  <div id="catTree" class="ztree" style="height: 300px;overflow-y: scroll;width: 80%;"></div>
                  <div id="searchCatTree" class="ztree" style="height: 300px;overflow-y: scroll;width: 80%;display:none"></div>
                </div>
              </div>
              <div style='display: flex;align-items: center'>
                <label style="width: 110px">时间范围:</label>
                <div class="cat-seletor-time"></div>
              </div>
              <div style='display: flex;align-items: center'>
                <label style="width: 110px">商品标题关键词:</label>
                <input class="title-input" type="input"
                placeholder="例如输入“益生菌”则筛选类目下标题含“益生菌”的商品数据"
                style="height: 26px; line-height: 26px;border-radius: 4px;border: 1px solid #DCDFE6; width: 70%; color: #3f3f3f;padding: 0 10px"
                value="${title}"/>
                <i class="el-icon-question title-question-icon"></i>
              </div>
              <div style='display: flex'>
                <label style="width: 110px">分析品牌:</label>
                <input class="brand-input" type="input"
                placeholder=""
                style="height: 26px; line-height: 26px;border-radius: 4px;border: 1px solid #DCDFE6; width: 70%; color: #3f3f3f;padding: 0 10px"
                value="${brand}"/>
              </div>
              <div style="display: flex; flex-direction: row-reverse;margin-right: 10px">
                <div class="el-button el-button--primary el-button--mini custom-confirm" style="font-size: 16px">确认继续生成答案</div>
                <img src="${shouzhi}" class="shouzhi-ani" style="width: 34px;margin-right: 10px"/>
              </div>
            </div>
</div>
  `
}

export function insertContent(originalString, insertString) {
  // 找到最后一个</div>的位置
    const lastDivIndex = originalString.lastIndexOf('</div>');

    // 如果找到了</div>，就在它前面插入字符串
    if (lastDivIndex !== -1) {
        // 将字符串分为两部分：前半部分和后半部分
        const beforeDiv = originalString.substring(0, lastDivIndex);
        const afterDiv = originalString.substring(lastDivIndex);

        // 插入字符串并返回结果
        return beforeDiv + insertString + afterDiv;
    } else {
        // 如果没有找到</div>，返回原始字符串
        return originalString;
    }
}

export function removeCatSelector() {
  // 获取所有类名为 'confim-param-area' 的元素
  const elements = document.querySelectorAll('.confirm-params-area');

  // 遍历元素并从 DOM 中移除
  elements.forEach(element => {
      element.remove(); // 删除元素及其子元素
  });

}

export function isFetchDone() {
  setTimeout(() => {
    const text = document.querySelector('.fetch-sub-title').innerText
    if(text.length < 2){
      const element = document.querySelector('.answer-fetch-title');
      if (element) {
        element.classList.add('fetch-done');
      }
    }else{
      return true
    }
  },300)


}

export const test_data = [
{'user': 'test_user', 'conv_id': 'test_conv_id', 'question_id': 'test_question_id_wanghao', 'msg_type': 'answer', 'speaker': 'ai', 'time': '2024-12-13 09:46:20.734452+08:00', 'module_type': 'analyse', 'message_content': '<div class="answer-analyse-title"><div class="analyse-title">分析问题</div><div class="analyse-sub-title">我正在分析您的问题.......</div></div><div class="answer-analyse-content">\n    <div class="answer-analyse-tools">\n        <div class="analyse-tools-title">预计需要调取以下工具:</div>\n        <div class="analyse-tools-card">\n        <div class="analyse-tools-card-title">\n            <span class="left">市场调研</span>\n            <span class="right">工具 1/2</span>\n        </div>\n        <div class="analyse-tools-card-content">\n            模块: 桌面调研\n        </div>\n    </div><div class="analyse-tools-card">\n        <div class="analyse-tools-card-title">\n            <span class="left">电商聆听</span>\n            <span class="right">工具 2/2</span>\n        </div>\n        <div class="analyse-tools-card-content">\n            模块: 方面/观点\n        </div>\n    </div>\n    </div>\n    <div class="analyse-info-card">\n        <div class="analyse-info-item">\n            <span class="analyse-info-name">时间范围</span>\n            <span class="analyse-info-content">2024-04~2024-09</span>\n        </div>\n        <div class="analyse-info-item">\n            <span class="analyse-info-name">目标平台</span>\n            <span class="analyse-info-content">[\'宠物/宠物食品及用品\']</span>\n        </div>\n        <div class="analyse-info-item">\n            <span class="analyse-info-name">分析类目</span>\n            <span class="analyse-info-content"></span>\n        </div>\n        <div class="analyse-info-item">\n            <span class="analyse-info-name">分析品牌</span>\n            <span class="analyse-info-content">猫主粮</span>\n        </div>\n        <div class="analyse-info-item">\n            <span class="analyse-info-name">分析关键词</span>\n            <span class="analyse-info-content">tmall</span>\n        </div>\n    </div>\n</div>\n'},


 {'user': 'test_user', 'conv_id': 'test_conv_id', 'question_id': 'test_question_id_wanghao', 'msg_type': 'answer', 'speaker': 'ai', 'time': '2024-12-13 09:46:29.083542+08:00', 'module_type': 'getdata', 'message_content': '<div class="answer-fetch-title" question_id="test_question_id_wanghao">\n    <div class="fetch-title">获取数据</div>\n    <div class="fetch-sub-title"></div>\n</div>'}
,{'user': 'test_user', 'conv_id': 'test_conv_id', 'question_id': 'test_question_id_wanghao', 'msg_type': 'answer', 'speaker': 'ai', 'time': '2024-12-13 09:47:38.693375+08:00', 'module_type': 'getsummary', 'message_content': '<div class="answer-generate-title">\n    <div class="generate-title">生成答案</div>\n    <div class="generate-sub-title"></div>\n</div>\n<div class="answer-generate-content">\n\n# 猫主粮口碑与痛点分析及新产品开发建议\n\n## 一、猫主粮的口碑情况\n通过对相关资料的分析，猫主粮的口碑呈现出复杂的情况。在社交媒体上，猫粮的提及率最高，这表明消费者对猫主粮的关注度较高，但同时也存在较多负面评价影响口碑<span class="ai-side" question_id="test_question_id_wanghao" class_id="96b2a56f-bcc8-4c45-af8d-6efbdc0a2149" >资料7</span>。\n\n## 二、消费者的痛点\n\n### （一）不良反应\n1. **健康问题**\n   - 在宠物冻干粮和冻干主粮的差评分析中，不良反应是消费者负面反馈最多的方面。例如，消费者评论宠物吃完后出现拉肚子、呕吐、便血、眼屎多、黑下巴、拉稀、大便臭等情况<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。这表明猫主粮在食用效果方面存在较大问题，影响了猫咪的健康，从而导致口碑受损。\n2. **适口性差**\n   - 部分猫主粮存在适口性问题，如猫粮适口性差，颗粒很大，猫咪不爱吃，没办法掺和着其他猫粮一起吃等情况被消费者提及<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。这对于猫主粮来说是一个重要的痛点，因为适口性直接关系到猫咪是否愿意食用该主粮。\n\n### （二）价格\n1. **价格上涨**\n   - 消费者对猫主粮价格方面存在不满，如价格越来越贵，涨价、价格促销机制不合理等情况被消费者反馈<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。价格的上涨可能会使消费者对产品的性价比产生质疑，影响购买意愿。\n2. **赠品减少**\n   - 有消费者反映购买猫主粮时送的东西越来越少，这也影响了消费者对产品整体价值的感知<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span>。\n\n### （三）成分\n1. **肉含量少**\n   - 消费者指出部分猫主粮中鸡肉鸭肉等肉类成分少得离谱，一桶里肉的含量很少，全是小麦高粱等谷物成分<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。由于猫咪是肉食动物，肉含量少不符合其饮食天性，这是消费者关注的一个痛点<span class="ai-side" question_id="test_question_id_wanghao" class_id="12e0c11b-d5fe-4744-8e64-bea9daa9694b" >资料4</span>。\n2. **疑似次品**\n   - 有部分消费者怀疑所购买的猫主粮为次品，感觉不干净，这也影响了产品的口碑和消费者的信任度<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。\n\n### （四）包装\n - 部分猫主粮存在包装问题，如包装密封性差，喂到后期容易潮等情况被消费者提及<span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。这可能会影响猫主粮的保存和质量，给消费者带来不便。\n\n### （五）正品疑虑\n - 不同渠道购买时，消费者对猫主粮是否为正品存在疑虑，如购买的三拼粮几乎看不到什么冻干，这让消费者怀疑产品的真实性<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="b648de6e-b699-4149-a657-4d67ec5a9cc8" >资料2</span>。\n\n### （六）店家服务\n - 店家服务也是一个痛点，如客户态度极差，售后服务差不肯退款、客服服务态度差、快递物流不及时等情况被消费者反馈<span class="ai-side" question_id="test_question_id_wanghao" class_id="6b0c6262-6285-4579-ada5-85fd1605eeb4" >资料1</span>。\n\n## 三、基于痛点的猫主粮产品开发建议\n\n### （一）健康与适口性方面\n1. **精选食材**\n   - 遵循猫咪肉食动物的天性，开发以鱼肉、鸡肉等各式肉类为主的主粮，并且保证肉的质量新鲜、无不良添加。可以采用鲜肉粮的形式，提高产品的品质，减少不良反应的发生<span class="ai-side" question_id="test_question_id_wanghao" class_id="12e0c11b-d5fe-4744-8e64-bea9daa9694b" >资料4</span>。\n2. **优化配方**\n   - 研发营养均衡的配方，关注猫咪的肠胃健康、泌尿系统健康和抵抗力等方面。例如，可以添加一些有助于消化和改善肠道菌群的成分，减少猫咪食用后出现呕吐、拉稀等不良反应的概率。同时，优化颗粒大小和口感，提高适口性，使猫咪更愿意食用<span class="ai-side" question_id="test_question_id_wanghao" class_id="12e0c11b-d5fe-4744-8e64-bea9daa9694b" >资料4</span>。\n\n### （二）价格方面\n1. **性价比策略**\n   - 制定合理的价格体系，在保证产品质量的前提下，控制成本，避免频繁涨价。可以推出不同规格和价格档次的产品，满足不同消费者的需求。例如，开发小包装的猫主粮，以相对较低的价格吸引消费者尝试，同时也适合猫咪更换周期快的特点<span class="ai-side" question_id="test_question_id_wanghao" class_id="12e0c11b-d5fe-4744-8e64-bea9daa9694b" >资料4</span>。\n2. **促销活动创新**\n   - 设计有吸引力的价格促销机制，如组合销售、满减、赠品等活动。但要注意赠品的质量和实用性，避免出现送的东西越来越少的情况，提高消费者对产品性价比的感知。\n\n### （三）成分方面\n1. **高肉无谷配方**\n   - 开发高肉无谷的猫主粮，减少谷物成分的使用，增加肉的含量。这不仅符合猫咪的饮食需求，也能满足消费者对“无谷”的关注，提高产品的品质形象<span class="ai-side" question_id="test_question_id_wanghao" class_id="12e0c11b-d5fe-4744-8e64-bea9daa9694b" >资料4</span><span class="ai-side" question_id="test_question_id_wanghao" class_id="96b2a56f-bcc8-4c45-af8d-6efbdc0a2149" >资料7</span>。\n2. **透明化成分**\n   - 在产品包装上清晰地标明成分及其比例，让消费者能够直观地了解产品的成分构成，增加消费者的信任度。\n\n### （四）包装方面\n1. **改进包装设计**\n   - 采用密封性好的包装材料，如带有密封条的包装袋或密封性能好的桶状包装，防止猫主粮受潮，延长产品的保质期。\n2. **方便性设计**\n   - 考虑包装的方便性，如易于开启和储存，方便消费者在日常使用中的操作。\n\n### （五）正品保障方面\n1. **渠道管理**\n   - 加强对销售渠道的管理，确保产品在各个渠道的质量和真实性。可以采用溯源系统等技术手段，让消费者能够查询产品的来源和真伪，消除消费者对正品的疑虑。\n2. **品牌标识**\n   - 在产品包装上设置明显的品牌标识和防伪标识，提高产品的辨识度，防止假冒伪劣产品的出现。\n\n### （六）店家服务方面\n1. **培训与监督**\n   - 对店家的员工进行培训，提高服务意识和专业水平，包括客服人员的沟通技巧、售后服务的处理能力等。同时，建立监督机制，对店家的服务质量进行定期评估和改进。\n2. **物流优化**\n   - 与可靠的物流合作伙伴合作，确保产品能够及时、准确地送达消费者手中，提高消费者的购物体验。\n</div>'}
]


// if (test_data.length > 0) {
//               test_data.forEach((item, index) => {
//                 if (item.msg_type == 'answer') {
//                   let content = item.message_content
//                   if (content.indexOf('analyse-title') > -1) {
//                     if (!item.parameter) {
//                       removeCatSelector()
//                       this.chatWindow.addBubble(
//                         content,
//                         function () {},
//                         'answer-title-wrap-v2 analyse-title-bubble',
//                         true
//                       )
//                     } else {
//                       const param = JSON.parse(item.parameter)
//                       const { cats, plat, title, entity } = param
//                       content = this.addFilterContent(param, content)
//                       this.chatWindow.addBubble(
//                         content,
//                         function () {},
//                         'answer-title-wrap-v2 analyse-title-bubble',
//                         true
//                       )
//                       this.questionId = item.question_id
//                       let platCats, platChildrenList
//                       let isOverseaPlat = this.isOverseaPlat(plat)
//                       let startWorker
//                       if (!isOverseaPlat) {
//                         if (
//                           plat.indexOf('taobao') > -1 ||
//                           plat.indexOf('tmall') > -1
//                         ) {
//                           platCats = window['cache_cat'].result.bigCategory
//                           platChildrenList =
//                             window['cache_cat'].result.childrenList
//                         } else if (plat == 'jd' || plat == '京东') {
//                           platCats = window['cache_cat_jd'].result.bigCategory
//                           platChildrenList =
//                             window['cache_cat_jd'].result.childrenList
//                         } else if (plat == 'douyin' || plat == '抖音') {
//                           platCats =
//                             window['cache_douyin_cats'].result.bigCategory
//                           platChildrenList =
//                             window['cache_douyin_cats'].result.childrenList
//                         } else {
//                           platCats = window['cache_cat'].result.bigCategory
//                           platChildrenList =
//                             window['cache_cat'].result.childrenList
//                         }
//                         startWorker = this.$refs.customCpn.startWorker
//                       } else {
//                         const plat_value = overseaPlatMap[plat]
//                         if (plat_value) {
//                           platCats =
//                             window['cache_cat_oversea_' + plat_value].result
//                               .bigCategory
//                           platChildrenList =
//                             window['cache_cat_oversea_' + plat_value].result
//                               .childrenList
//                           startWorker = this.$refs.customCpn.startOverseaWorker
//                         } else {
//                           platCats = window['cache_cat'].result.bigCategory
//                           platChildrenList =
//                             window['cache_cat'].result.childrenList
//                           startWorker = this.$refs.customCpn.startWorker
//                         }
//                       }
//                       startWorker(platCats, platChildrenList, 'all', plat).then(
//                         (res) => {
//                           this.zNodes = res
//                           this.initCatTree()
//                           this.checkDefaultCats(cats)
//                         }
//                       )
//                       $('.stop-wrap-div').show()
//                       clearInterval(this.interval)
//                       this.addLoader()
//                       this.isLock = true
//                       this.chatWindow.lock(true)

//                       setTimeout(() => {
//                         document
//                           .querySelector('.custom-confirm')
//                           .addEventListener('click', (evt) => {
//                             this.confirmHandler(plat, entity)
//                             this.removeFifteenBubble()
//                             if (this.fifteenTimeout) {
//                               clearTimeout(this.fifteenTimeout)
//                               this.fifteenTimeout = ''
//                             }
//                           })
//                         $('#catSearchBtn').click((evt) => {
//                           evt.preventDefault() // 阻止默认行为，比如表单提交等
//                           this.searchChange()
//                         })
//                         $('#catSearchInput').on('keyup', (event) => {
//                           if (event.keyCode === 13) {
//                             // enter键
//                             event.preventDefault() // 阻止默认行为，比如表单提交等
//                             this.searchChange()
//                           }
//                         })
//                         this.addQuestionPoP()
//                       }, 500)
//                       this.fifteenTimeout = setTimeout(() => {
//                         this.addFifteenBubble()
//                       }, 15000)
//                     }
//                   } else if (content.indexOf('fetch-title') > -1) {
//                     this.chatWindow.addBubble(
//                       content,
//                       function () {},
//                       'answer-title-wrap-v2 ',
//                       true
//                     )
//                     isFetchDone()
//                     if (index == test_data.length - 1) {
//                       this.showRightAsideMethods(true)
//                     }
//                   } else if (content.indexOf('generate-title') > -1) {
//                     const md = new MarkdownIt({
//                       html: true, // 允许解析 HTML
//                     })
//                     console.log(content)
//                     const htmlOutput = md.render(content)
//                     console.log(htmlOutput)
//                     // 输出完整的 HTML，HTML 部分直接保留，Markdown 部分转为 HTML

//                     this.chatWindow.addBubble(
//                       htmlOutput,
//                       function () {},
//                       'answer-title-wrap-v2 ',
//                       true
//                     )
//                   }
//                 }
//               })
//             }
